import './theme/palette.css';   // 3.44.0: every colour as a variable (themes and dark mode override them)
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import reportWebVitals from './reportWebVitals';
import { startUpdateChecks } from './utils/appUpdate';

// 3.62.30: an open portal loads a new deployment by itself, at a safe moment
startUpdateChecks();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// 3.52.0: the installable app's background helper (public/sw.js): keeps only
// the portal's own code and pictures; live copies only (not npm start)
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/sw.js`, { scope: `${process.env.PUBLIC_URL}/` }).catch(() => {});
  });
}
